import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import markup from "ulysses/widgets/search/fixed_search.html";
import "ulysses/widgets/search/search";
import "ulysses/controls/scroller";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

function edit_fixedsearch_settings(current_data) {
    var res = Promise.Deferred();
    var cdata = $.extend({"relation":null, "filter":null}, ko.toJS(current_data));
    console.log("got cdata:", cdata);

    require(["ulysses/widgets/search/fixed_search_editor.html"], function(editor_markup) {
        var dialog = uly.dialogs.execute(editor_markup, {
            "title":_("fixed_search_title_edit_widget_configuration", "Edit Widget Configuration")
        }, cdata).done(function([result]) {
            res.resolve({
                "relation":ko.unwrap(result.relation) || null,
                "filter":ko.unwrap(result.filter) || null,
                "display_mode":ko.unwrap(result.display_mode) || "list"
            });
        }).fail(res.reject);
    });
    return res.promise();
}

function ensure_settings(widget_model) {
    var settings = ko.unwrap(widget_model.settings);
    if (typeof settings.filter != "function")
        settings.filter = ko.observable(settings.filter || null);
    if (typeof settings.relation != "function")
        settings.relation = ko.observable(settings.relation || null);

}
ko.bindingHandlers.fixedsearch = {
    initial_value: function() {
        var data = {
            "relation": ko.observable(null),
            "filter":ko.observable(null),
            "display_mode": ko.observable("list")
        };
        var init_def = Promise.Deferred();
        edit_fixedsearch_settings(data).done(function(result) {
            data.filter(result.filter);
            data.relation(result.relation);
            data.display_mode(result.display_mode);
            init_def.resolve(data);
        }).fail(init_def.reject);
        return init_def;
    },
    init: function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.title(_("fixed_search_loading", "loading..."));
        widget_model.icon("fa fa-newspaper-o");
        widget_model.show_header(true);
        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("fixed_search_caption_modify", "Modify"), "icon":"fa-edit", "action":function(e){
                var settings = ko.toJS(ko.unwrap(widget_model.settings));
                return edit_fixedsearch_settings(settings).done(function(result) {
                    var new_settings = {
                        "filter": result.filter,
                        "relation": result.relation,
                        "display_mode": result.display_mode
                    };
                    widget_model.settings(new_settings);
                    uly.publish("page.savesettings");

                });
            },"colour":"default"
        });

        var data = {
            filter: ko.pureComputed(function() {
                return ko.unwrap(ko.unwrap(widget_model.settings).filter);
            }),
            relation: ko.pureComputed(function() {
                return ko.unwrap(ko.unwrap(widget_model.settings).relation);
            }),
            remove_action: function(ev) {
                var bindingcontext = ko.contextFor($(ev.target)[0]);
                if (context.widget_list) {
                    context.widget_list.splice(ko.unwrap(context.$index), 1);
                    uly.publish("page.savesettings");
                }
            },
            edit_settings: function(ev) {
                edit_fixedsearch_settings(ko.unwrap(widget_model.settings)).done(function(result) {
                    var new_settings = {
                        "filter": result.filter,
                        "relation": result.relation,
                        "display_mode": result.display_mode
                    };
                    widget_model.settings(new_settings);
                    uly.publish("page.savesettings");
                });
            },
            settings: widget_model.settings
        };
        ko.unwrap(widget_model.settings).strong=true;
        var child = context.createChildContext(data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    update: function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.show_header(false);
        widget_model.panel_class(widget_model.panel_class().replace("box-primary", "box-no-header"));

    }
};

uly.widgets.register({
    "type":"fixedsearch",
    "caption":_("fixed_search_caption_fixed_results", "Fixed Results"),
    "description":_("fixed_search_description_a_set_of_records", "A set of records"),
    "icon":"fa-newspaper-o",
    "init":ko.bindingHandlers.fixedsearch.initial_value,
    "colour":"java",
    "actions":[{
        "caption":_("fixed_search_caption_settings", "Settings"),
        "icon":"fa-cog",
        "action":function(e){
            return false;
        },
        "colour":"default"
    }]
});
